export const environment = {
  production: false,
  testMode: true,
  authServiceUrl: 'https://legitimera-admin-test.internal.sparbankensyd.se/service',
  bilAPIUrl: 'https://legitimera-admin-test.internal.sparbankensyd.se/bil',
  domain: 'legitimera-admin-stage.internal.sparbankensyd.se'
}
